import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
import { BrowserTracing } from '@sentry/tracing'
import * as Sentry from '@sentry/vue'
// See https://github.com/ecomfe/vue-echarts#installation--usage
import { BarChart, LineChart, PieChart, ScatterChart } from 'echarts/charts'
import {
  DataZoomInsideComponent,
  GridComponent,
  LegendComponent,
  SingleAxisComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components'
import { use } from 'echarts/core'
import 'echarts/lib/component/markArea'
import 'echarts/lib/component/markLine'
import { CanvasRenderer } from 'echarts/renderers'
import 'mapbox-gl/dist/mapbox-gl.css'
import VCalendar from 'v-calendar'
import Vue from 'vue'
import { VueCsvImport } from 'vue-csv-import'
import ECharts from 'vue-echarts'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import Notifications from 'vue-notification'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import FormSection from '@/components/Form/Section/index.vue'
import Link from '@/components/Link.vue'

import App from '@/App.vue'
import { i18n } from '@/i18n'
import router from '@/router'
import store from '@/store'

use([
  CanvasRenderer,
  LineChart,
  PieChart,
  BarChart,
  ScatterChart,
  GridComponent,
  TooltipComponent,
  DataZoomInsideComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  SingleAxisComponent,
])

Vue.component('e-chart', ECharts)
Vue.component('Link', Link)

Vue.use(VCalendar, {
  locales: {},
})

Vue.use(VueGoodTablePlugin)
Vue.use(Notifications)
Vue.use(VueCsvImport)

Vue.component('v-select', vSelect)
Vue.component('FormSection', FormSection)

Vue.config.productionTip = false

const unsupportedSentryEnvironments = ['development', 'test']
if (!unsupportedSentryEnvironments.includes(process.env.NODE_ENV)) {
  Sentry.init({
    Vue: Vue,
    dsn: 'https://e5f45e93501f47f890bbd8fd282975de@o1082260.ingest.sentry.io/6454086',
    environment: process.env.SENTRY_ENVIRONMENT,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['app.binity.io', /^\//],
      }),
    ],
    tracesSampleRate: 0.2,
  })
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
